import { gsap } from 'gsap';

class SchedulerForm {
    constructor(element, dropdownMapUS, dropdownMapCanada) {
        this.element = element;
        this.dropdownMapUS = dropdownMapUS;
        this.dropdownMapCanada = dropdownMapCanada;
        this.dropdownUS = element.querySelector('.scheduler-us-dropdown');
        this.dropdownCanada = element.querySelector(
            '.scheduler-canada-dropdown'
        );
        this.schedulerFormUS = element.querySelector('.form-container-us');
        this.schedulerFormCanada = element.querySelector('.form-container-canada');
        this.dropdownCountry = element.querySelector('.scheduler-country-dropdown');
        this.link = element.querySelector('.scheduler-link');
    }

    init() {
        this.dropdownCountry.addEventListener(
            'change',
            this.onDropdownChangeCountry.bind(this)
        );
        this.dropdownUS.addEventListener(
            'change',
            this.onDropdownChangeUS.bind(this)
        );
        this.dropdownCanada.addEventListener(
            'change',
            this.onDropdownChangeCanada.bind(this)
        );
    }

    onDropdownChangeUS(event) {
        const selectedValue = event.currentTarget.value;
        let newDestination = this.dropdownMapUS[selectedValue];
        if (!newDestination) newDestination = this.dropdownMapUS.default;
        this.link.setAttribute('href', newDestination);
        this.link.style.display = 'block';
        this.link.focus();
    }

    onDropdownChangeCanada(event) {
        const selectedValue = event.currentTarget.value;
        let newDestination = this.dropdownMapCanada[selectedValue];
        if (!newDestination) newDestination = this.dropdownMapCanada.default;
        this.link.setAttribute('href', newDestination);
        this.link.style.display = 'block';
        this.link.focus();
    }

    onDropdownChangeCountry(event) {
        const selectedValue = event.currentTarget.value;
        if (selectedValue === 'US') {
            this.schedulerFormUS.style.display = 'block';
            this.schedulerFormUS.style.opacity = 1;
            if(this.schedulerFormCanada) {
                this.link.style.display = 'none';
                this.schedulerFormCanada.style.display = 'none';
                this.schedulerFormCanada.style.opacity = 0;
            }
        }
        if (selectedValue === 'Canada') {
            this.schedulerFormCanada.style.display = 'block';
            this.schedulerFormCanada.style.opacity = 1;
            if(this.schedulerFormUS) {
                this.link.style.display = 'none';
                this.schedulerFormUS.style.display = 'none';
                this.schedulerFormUS.style.opacity = 0;
            }
        }
        if (selectedValue === 'Outside') {
            let destination = 'https://meetings.hubspot.com/michael-morgan4/michael-morgan';
            this.link.setAttribute('href', destination);
            this.link.style.display = 'block';
            this.link.focus();
            if(this.schedulerFormUS || this.schedulerFormCanada) {
                this.schedulerFormUS.style.display = 'none';
                this.schedulerFormUS.style.opacity = 0;
                this.schedulerFormCanada.style.display = 'none';
                this.schedulerFormCanada.style.opacity = 0;
            }
        }
    }
}

class NextStepForm {
    constructor(element) {
        this.element = element;
        this.nextStepButtons =
            this.element.querySelectorAll('.next-step-button');
        this.closeNextStepButtons =
            this.element.querySelectorAll('.next-step-close');
        this.nextStepForms = this.element.querySelectorAll('.next-step');
        this.openForm = null;
        this.resizeObserver = null;
        this.resizeObserverElement = element.querySelector('.resize-observer');
        this.prevTransitioningToHeight = 0;
        this.transitioningToHeight = 0;
    }

    init() {
        this.nextStepButtons.forEach((button) => {
            button.addEventListener('click', this.onNextStep.bind(this));
        });

        this.closeNextStepButtons.forEach((button) => {
            button.addEventListener(
                'click',
                this.onCloseNextStepClick.bind(this)
            );
        });

        this.resizeObserver = new ResizeObserver(
            this.updateResizeObserverElementHeight.bind(this)
        );
        this.nextStepForms.forEach((product) => {
            this.resizeObserver.observe(product);
        });

        if (this.nextStepButtons.length) {
            this.openNextStepButton(this.nextStepButtons[0], false);
        }
    }

    getCurrentSelectedButton() {
        return this.element.querySelector(
            '.next-step-button[aria-expanded="true"]'
        );
    }

    onCloseNextStepClick() {
        this.getCurrentSelectedButton().focus();
        this.closeNextStep();
    }

    updateResizeObserverElementHeight() {
        const maxSize = [...this.nextStepForms].reduce(
            (acc, el) => Math.max(acc, el.getBoundingClientRect().height),
            0
        );
        // E.g. of the last 2 transitions, never be less than the smaller of the two
        const minTransitioningToHeight = Math.min(
            this.prevTransitioningToHeight,
            this.transitioningToHeight
        );
        this.resizeObserverElement.style.height = `${Math.max(maxSize, minTransitioningToHeight)}px`;
    }

    openNextStep(nextStepForm, conditionallyScroll = true) {
        this.updateResizeObserverElementHeight();
        const isTopInViewport = (element) => {
            const rect = element.getBoundingClientRect();
            const viewportHeight =
                window.innerHeight || document.documentElement.clientHeight;
            return rect.top >= 0 && rect.top <= viewportHeight;
        };

        gsap.set(nextStepForm, {
            height: 'auto',
            display: 'block',
            opacity: 1,
            zIndex: 20
        });

        this.transitioningToHeight = nextStepForm.offsetHeight;

        const thisObj = this;

        gsap.from(nextStepForm, {
            duration: 0.3,
            height: 0,
            opacity: 0,
            onComplete: () => {
                // eslint-disable-next-line no-param-reassign
                nextStepForm.style.height = 'auto';
                thisObj.updateResizeObserverElementHeight();
                if (!isTopInViewport(nextStepForm) && conditionallyScroll) {
                    window.scrollTo({
                        top:
                            nextStepForm.getBoundingClientRect().top +
                            document.documentElement.scrollTop -
                            20,
                        behavior: 'smooth'
                    });
                }
                this.prevTransitioningToHeight = this.transitioningToHeight;
                this.transitioningToHeight = 0;
            }
        });

        this.openForm = nextStepForm;
    }

    closeNextStep() {
        this.updateResizeObserverElementHeight();
        const currentlySelectedButton = this.getCurrentSelectedButton();
        if (currentlySelectedButton) {
            currentlySelectedButton.classList.remove('before:opacity-100');
            currentlySelectedButton.classList.add('before:opacity-0');
        }

        const thisObj = this;
        if (!this.openForm) return;

        const gsapConfig = {
            duration: 0.3,
            height: 0,
            opacity: 0,
            display: 'none',
            zIndex: 10,
            onComplete() {
                thisObj.updateResizeObserverElementHeight();
            }
        };

        this.updateAriaExpanded(this.openForm.id, false);

        gsap.to(this.openForm, gsapConfig);
        this.openForm = null;
    }

    openNextStepButton(button, conditionallyScroll = true) {
        const targetId = button.getAttribute('aria-controls');
        const target = this.element.querySelector(`#${targetId}`);

        button.classList.remove('before:opacity-0');
        button.classList.add('before:opacity-100');

        if (this.openForm !== target) {
            this.closeNextStep();
            this.openNextStep(target, conditionallyScroll);
        }

        this.updateAriaExpanded(targetId, true);
    }

    onNextStep(event) {
        this.openNextStepButton(event.currentTarget);
    }

    // eslint-disable-next-line class-methods-use-this
    updateAriaExpanded(elementId, isExpanded) {
        document
            .querySelectorAll(`[aria-controls="${elementId}"]`)
            .forEach((element) => {
                element.setAttribute('aria-expanded', isExpanded);
            });
    }
}

document.addEventListener('DOMContentLoaded', () => {
    const schedulerForms = document.querySelectorAll('.scheduler-form');
    schedulerForms.forEach((element) => {
        const dropdownMapUS = {
            default: 'https://meetings.hubspot.com/brian-gravel',
            Northeast: 'https://meetings.hubspot.com/brian-gravel',
            Atlantic: 'https://meetings.hubspot.com/lauren-curnutte',
            'Great Lakes': 'https://meetings.hubspot.com/marc-russell1',
            Southwest: 'https://learn.sentinelu.com/meetings/glenn-davis',
            West: 'https://learn.sentinelu.com/meetings/daniel-krebs'
        };
        const dropdownMapCanada = {
            default: 'https://meetings.hubspot.com/brian-gravel',
            Eastern: 'https://meetings.hubspot.com/brian-gravel',
            Central: 'https://meetings.hubspot.com/marc-russell1',
            Western: 'https://learn.sentinelu.com/meetings/daniel-krebs'
        };
        const schedulerForm = new SchedulerForm(element, dropdownMapUS, dropdownMapCanada);
        schedulerForm.init();
    });

    const nextStepForms = document.querySelectorAll('.next-step-form');
    nextStepForms.forEach((element) => {
        const nextStepForm = new NextStepForm(element);
        nextStepForm.init();
    });
});

